function prepareSnapshots({ view, splitByMode, }) {
    let snapshots = [];
    Object.values(view._idToPrepared).forEach((rawStory) => {
        var _a, _b;
        let modesArray = [modes.DEFAULT_MODE];
        if (((_a = rawStory.parameters.sherlo) === null || _a === void 0 ? void 0 : _a.mode) && splitByMode) {
            const mode = (_b = rawStory.parameters.sherlo) === null || _b === void 0 ? void 0 : _b.mode;
            if (mode === modes.DEFAULT_MODE || mode === modes.FULL_HEIGHT_MODE) {
                modesArray = Array.isArray(mode) ? mode : [mode];
            }
        }
        modesArray.forEach((mode) => {
            var _a, _b;
            if (mode === modes.DEFAULT_MODE || mode === modes.FULL_HEIGHT_MODE) {
                let sherloParameters = rawStory.parameters.sherlo || {};
                if ((_b = (_a = rawStory.parameters) === null || _a === void 0 ? void 0 : _a.design) === null || _b === void 0 ? void 0 : _b.url) {
                    sherloParameters = { figmaUrl: rawStory.parameters.design.url, ...sherloParameters };
                }
                snapshots.push({
                    viewId: `${rawStory.id}-${mode}`,
                    mode: modes.DEFAULT_MODE,
                    displayName: `${rawStory.title} - ${rawStory.name}`,
                    sherloParameters,
                    componentId: rawStory.componentId,
                    componentTitle: rawStory.title,
                    storyId: rawStory.id,
                    storyTitle: rawStory.name,
                    parameters: rawStory.parameters,
                    argTypes: rawStory.argTypes,
                    args: rawStory.initialArgs,
                });
            }
        });
    });
    return snapshots.reverse();
}
export default prepareSnapshots;
/* ========================================================================== */
const modes = {
    DEFAULT_MODE: 'deviceHeight',
    FULL_HEIGHT_MODE: 'fullHeight',
};
//# sourceMappingURL=prepareSnapshots.js.map